import { render } from "./DetailsView.vue?vue&type=template&id=fd5194de&scoped=true"
import script from "./DetailsView.vue?vue&type=script&lang=js"
export * from "./DetailsView.vue?vue&type=script&lang=js"

import "./DetailsView.vue?vue&type=style&index=0&id=fd5194de&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-fd5194de"]])

export default __exports__